
import processImageLink from '../../mixins/processImageLink.js'

export default {
  name: 'BlogGrid',
  props: {
    data: {
      type: Object,
      default: () => { },
    },
  },
  mixins: [processImageLink],
  data() {
    return {
      // blogCategories: []
    }
  },
  computed: {
    blogCategoriesComputed() {
      const uniqueIds = [];

      if (this.data?.blog_categories) {
        const unique = this.data?.blog_categories.filter(element => {
          const isDuplicate = uniqueIds.includes(element?.DisplayName);
          if (!isDuplicate && !this.isFunctionalBlogTag(element?.TagCode)) {
            uniqueIds.push(element?.DisplayName);
            return true;
          }
          return false;
        });
        return unique
      }
      return []
    }
  },
  methods: {
    isFunctionalBlogTag(tagCode) {
      return tagCode?.includes("fn-")
    },
  },
}
